import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

// ---- Public catalog ----
export const fetchProducts = (params = {}) =>
  client.get("/products", { params }).then((r) => r.data);
export const fetchProduct = (id) => client.get(`/products/${id}`).then((r) => r.data);
export const fetchCategories = () => client.get("/categories").then((r) => r.data);
export const fetchCategory = (id) => client.get(`/categories/${id}`).then((r) => r.data);

// ---- Checkout ----
export const createCheckout = (payload) =>
  client.post("/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) =>
  client.get(`/payments/status/${sessionId}`).then((r) => r.data);
export const scheduleOrder = (sessionId, payload) =>
  client.post(`/orders/${sessionId}/schedule`, payload).then((r) => r.data);
export const sendContact = (payload) => client.post("/contact", payload).then((r) => r.data);

// ---- Auth ----
export const postSession = (sessionId) =>
  client.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } }).then((r) => r.data);
export const fetchMe = () => client.get("/auth/me").then((r) => r.data);
export const logout = () => client.post("/auth/logout").then((r) => r.data);

// ---- Customer account ----
export const myOrders = () => client.get("/my/orders").then((r) => r.data);
export const getWishlist = () => client.get("/my/wishlist").then((r) => r.data);
export const addWishlist = (product_id) => client.post("/my/wishlist", { product_id }).then((r) => r.data);
export const removeWishlist = (product_id) => client.delete(`/my/wishlist/${product_id}`).then((r) => r.data);

// ---- Admin ----
export const adminStats = () => client.get("/admin/stats").then((r) => r.data);
export const adminCreateProduct = (p) => client.post("/admin/products", p).then((r) => r.data);
export const adminUpdateProduct = (id, p) => client.put(`/admin/products/${id}`, p).then((r) => r.data);
export const adminDeleteProduct = (id) => client.delete(`/admin/products/${id}`).then((r) => r.data);
export const adminCreateCategory = (c) => client.post("/admin/categories", c).then((r) => r.data);
export const adminUpdateCategory = (id, c) => client.put(`/admin/categories/${id}`, c).then((r) => r.data);
export const adminDeleteCategory = (id) => client.delete(`/admin/categories/${id}`).then((r) => r.data);
export const adminOrders = (params = {}) => client.get("/admin/orders", { params }).then((r) => r.data);
export const adminMessages = () => client.get("/admin/messages").then((r) => r.data);
export const adminUpdateOrder = (id, fulfillment_status) =>
  client.put(`/admin/orders/${id}`, { fulfillment_status }).then((r) => r.data);
export const adminDeleteOrder = (id) => client.delete(`/admin/orders/${id}`).then((r) => r.data);

// ---- Blocked dates (holidays) ----
export const fetchBlockedDates = () => client.get("/blocked-dates").then((r) => r.data);
export const fetchSlotAvailability = (date, kind) =>
  client.get("/slot-availability", { params: { date, kind } }).then((r) => r.data);
export const adminBlockedDates = () => client.get("/admin/blocked-dates").then((r) => r.data);
export const adminAddBlockedDate = (payload) => client.post("/admin/blocked-dates", payload).then((r) => r.data);
export const adminDeleteBlockedDate = (id) => client.delete(`/admin/blocked-dates/${id}`).then((r) => r.data);

// ---- Admin settings & reports ----
export const adminGetSettings = () => client.get("/admin/settings").then((r) => r.data);
export const adminUpdateSettings = (payload) => client.put("/admin/settings", payload).then((r) => r.data);
export const adminSalesReport = () => client.get("/admin/sales-report").then((r) => r.data);

// ---- Image upload (admin) ----
export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return client.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => `${BACKEND_URL}${r.data.url}`);
};

// ---- Email diagnostics (admin) ----
export const adminEmailHealth = () => client.get("/admin/email-health").then((r) => r.data);
export const adminSendTestEmail = (to) => client.post("/admin/test-email", { to }).then((r) => r.data);
export const adminSaveEmailConfig = (payload) => client.post("/admin/email-config", payload).then((r) => r.data);

export default client;
